import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Card, Button, Flex, Text, Box } from 'pcln-design-system'
import { Search, Filter, ArrowRight, ArrowLeft } from 'pcln-icons'

//TODO: Find a design system color that can work for this button (none currently similar)
const StyledButton = styled(Button)`
  background: #3a80f3;
`

const MobileHeaderCard = ({
  toggleIsOpen,
  filterOnClick,
  origin,
  destination,
  date,
  hideFilter,
  backArrowClick,
}) => (
  <Card color='primary.base' p={2}>
    <Flex alignItems={backArrowClick ? 'center' : null}>
      {backArrowClick ? (
        <Box mr={2} title='Back to Flight Results' onClick={backArrowClick}>
          <ArrowLeft size={23} />
        </Box>
      ) : null}
      <StyledButton mr={2} width={1} p={2} onClick={toggleIsOpen}>
        <Flex alignItems='center'>
          <Search />
          <Text textAlign='left' ml={2} fontSize={0}>
            <Flex alignItems='center'>
              <Text fontWeight='bold'>{origin}</Text>
              <ArrowRight size={14} mx={1} />
              <Text fontWeight='bold'>{destination}</Text>
            </Flex>
            <Text fontSize={1} fontWeight='regular'>
              {date}
            </Text>
          </Text>
        </Flex>
      </StyledButton>
      {!hideFilter ? (
        <Button py={1} px={3} onClick={filterOnClick}>
          <Filter />
          <Text mt={-1} fontSize={0} fontWeight='regular'>
            Filters
          </Text>
        </Button>
      ) : null}
    </Flex>
  </Card>
)

MobileHeaderCard.propTypes = {
  toggleIsOpen: PropTypes.func,
  filterOnClick: PropTypes.func,
  origin: PropTypes.string,
  destination: PropTypes.string,
  date: PropTypes.string,
  hideFilter: PropTypes.bool,
  backArrowClick: PropTypes.func,
}

export { MobileHeaderCard }
